const mutations = {
  setLocalPosition(state, localPosition) {
    state.localPosition = localPosition
  },
  setUserinfo(state, userinfo) {
    state.userinfo = userinfo
  },
  setUnionid(state, unionid) {
    state.unionid = unionid
  },
  setSearchCondition(state, searchCondition) {
    state.searchCondition = searchCondition
  },
  setCity(state, city) {
    state.city = city
  },
  setSearchModule(state, searchModule) {
    state.searchModule = searchModule
  },
  setMealDetail(state, mealDetail) {
    state.mealDetail = mealDetail
  },
  setOrderUserInfo(state, orderUserInfo) {
    state.orderUserInfo = orderUserInfo
  },
  setDateChosen(state, dateChosen) {
    state.dateChosen = dateChosen
  },
  setVoucher(state, voucher) {
    state.voucher = voucher
  },
  setMealPersonInfo(state, mealPersonInfo) {
    state.mealPersonInfo = mealPersonInfo
  },
  setSwitchCity(state, switchCity) {
    state.switchCity = switchCity
  },
  setEchartsData(state, echartsData) {
    state.echartsData = echartsData
  },
  setAssessmentData(state, assessmentData) {
    state.assessmentData = assessmentData
  },
  setSelectItemList(state, selectItemList) {
    state.selectItemList = selectItemList
  },
  setSelectItemContentList(state, selectItemContentList) {
    state.selectItemContentList = selectItemContentList
  },
  setSelectItemPackageList (state, selectItemPackageList) {
    state.selectItemPackageList = selectItemPackageList
  },
  setSelectItemPackageContentList (state, selectItemPackageContentList) {
    state.selectItemPackageContentList = selectItemPackageContentList
  },
  setAddItemPrice (state, addItemPrice) {
    state.addItemPrice = addItemPrice
  },
  setRecommendResult(state, recommendResult) {
    state.recommendResult = recommendResult
  },
  setMedicineChineseConfig(state, medicineChineseConfig) {
    state.medicineChineseConfig = medicineChineseConfig
  },
  // 设置openId
  setDeviceOpenId(state, openId) {
    state.deviceOpenId = openId
  },
  // 设置用户详细数据
  setDeviceUserDetails(state, user) {
    state.deviceUserDetails = user
  },
  setMedicineChineseIdentifyType (state, medicineChineseIdentifyType){
    state.medicineChineseIdentifyType = medicineChineseIdentifyType
  },
  setOrderDetail (state, orderDetail) {
    state.orderDetail = orderDetail
  },
  setInvoiceDetail (state, invoiceDetail) {
    state.invoiceDetail = invoiceDetail
  },
  setInvoiceMoreInfo (state, invoiceMoreInfo) {
    state.invoiceMoreInfo = invoiceMoreInfo
  },
  setIsFirst (state, isFirst) {
    state.isFirst = isFirst
  },
  setQuickQuestionInfo(state, quickQuestionInfo) {
    state.quickQuestionInfo = quickQuestionInfo
  },
  resetQuickQuestionInfo(state) {
    state.quickQuestionInfo = null
  },
  setSelectReportInfo (state, report) {
    state.selectReportInfo = report
  },
  resetSelectReportInfo (state) {
    state.selectReportInfo = null
  },
  setIsEvaluationUnFinish (state, status) {
    state.isEvaluationUnFinish = status
  },
  setQuestionRobotInfo (state, questionRobotInfo) {
    state.questionRobotInfo = questionRobotInfo
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js